import { IoMdMenu } from "react-icons/io";
import { useLocation } from "react-router-dom";
import AdminHeader from "./admin/TopMenu";
import ParentHeader from "./parent/ParentTopMenu";
import SchoolHeader from "./school/SchoolHeader";
import VendorHeader from "./vendor/VendorHeader";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLogoutMutation } from "../store/api/authSlice";
import { logOutUser } from "../store/reducer/UserReducer";
import { removeToken } from "../utils/localStorageMethods";
import LanguageSlector from "./languageSlector";
import { purgeStore } from "../store/store";

const Header = ({ isCollapsed, onToggleSidebar }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.UserReducer);
  const role = user?.role === "super_admin" ? "admin" : user?.role;

  let path = location.pathname
    .split("/")[1]
    .replace("/", "")
    .replace("-", " ")
    .replace("-", " ");

  if (location.pathname === "/my-school-reservations") {
    path = t("reservations");
  }
  if (location.pathname === "/ask-ai") {
    path = t("topBar.ask-Ai");
  }
  if (location.pathname === "/tracking") {
    path = t("tracking");
  }
  if (location.pathname === "/manage-kids") {
    path = `${t("manage")} ${t("kids")}`;
  }
  if (location.pathname === "/reservations") {
    path = t("reservations");
  }
  if (location.pathname === "/cancel-reservation") {
    path = `${t("cancel")} ${t("reservations")}`;
  }
  if (location.pathname === "/rides-completed") {
    path = `${t("rides")} ${t("completed")}`;
  }
  if (location.pathname === "/profile") {
    path = `${t("my")} ${t("profile")}`;
  }
  if (location.pathname === "/school-bank-details") {
    path = `${t("school")} ${t("bank")} ${t("account")} ${t("details")}`;
  }
  if (location.pathname === "/bank-details") {
    path = `${t("admin")} ${t("bank")} ${t("account")} ${t("details")}`;
  }
  if (location.pathname === "/vendor-bank-details") {
    path = `${t("vendor")} ${t("bank")} ${t("account")} ${t("details")}`;
  }
  if (location.pathname === "/vendors") {
    path = `${t("vendors")}`;
  }
  if (location.pathname === "/regulatory-compliance") {
    path = `${t("regulatory")} ${t("compliance")}`;
  }
  if (location.pathname === "/regulatory-compliance/add") {
    path = `${t("add")} ${t("regulatory")} ${t("compliance")}`;
  }
  if (location.pathname.startsWith("/regulatory-compliance/edit")) {
    path = `${t("edit")} ${t("regulatory")} ${t("compliance")}`;
  }
  if (location.pathname === "/parents") {
    path = `${t("parents")}`;
  }
  if (location.pathname === "/parents/add") {
    path = `${t("add")} ${t("parent")}`;
  }
  if (location.pathname.startsWith(`/parents/edit/`)) {
    path = `${t("edit")} ${t("parent")}`;
  }
  if (location.pathname.endsWith("/students")) {
    path = `${t("students")}`;
  }
  if (location.pathname.endsWith("/schedules")) {
    path = `${t("driver")} ${t("Schedules")}`;
  }
  if (location.pathname.endsWith("/schedules/add")) {
    path = `${t("add")} ${t("driver")} ${t("Schedules")}`;
  }
  if (location.pathname.includes("/schedules/edit")) {
    path = `${t("update")} ${t("driver")} ${t("schedules")}`;
  }
  if (location.pathname === "/dashboard") {
    path = t("dashboard");
  }
  if (location.pathname === "/my-bus-reservations") {
    path = `${t("my")} ${t("bus")} ${t("reservations")}`;
  }
  if (location.pathname === "/payment-plans") {
    path = `${t("plans")} & ${t("payments")} ${t("management")}`;
  }
  if (location.pathname === "/school-vehicles") {
    path = `${t("school")} ${t("vehicles")}`;
  }
  if (location.pathname === "/vendor-vehicles") {
    path = `${t("vendor")} ${t("vehicles")}`;
  }
  if (location.pathname === "/schools") {
    path = `${t("my")} ${t("schools")}`;
  }
  if (location.pathname === "/school-drivers") {
    path = `${t("school")} ${t("drivers")}`;
  }
  if (location.pathname === "/vendor-drivers") {
    path = `${t("vendor")} ${t("drivers")}`;
  }
  if (location.pathname === "/school-parents") {
    path = `${t("school")} ${t("parents")}`;
  }
  if (location.pathname === "/vendor-parents") {
    path = `${t("vendor")} ${t("parents")}`;
  }
  if (location.pathname === "/user-management") {
    path = `${t("user")} ${t("management")}`;
  }
  if (location.pathname === "/user-management/add") {
    path = `${t("add")} & ${t("user")}`;
  }
  if (
    location.pathname === "/my-bus-reservations/book" ||
    location.pathname === "/my-busing-subscriptions/book" ||
    location.pathname === "/vehicles"
  ) {
    path = `${t("vehicles")}`; // ${t("school")}
  }
  if (location.pathname.startsWith("/bus-charter-reservations/vendors/book")) {
    path = `${t("vendors")} ${t("vehicles")}`;
  }
  if (
    location.pathname === "/bus-charter-reservations/vendors" ||
    location.pathname === "/busing-subscriptions/vendors"
  ) {
    path = `${t("vendors")}`;
  }
  if (location.pathname === "/payment-history") {
    path = `${t("my")} ${t("subscription")} ${t("history")}`;
  }
  if (location.pathname === "/parent-payments-received") {
    path = `${t("parent")} ${t("payments")} ${t("history")}`;
  }
  if (location.pathname === "/my-payment-history") {
    path = `${t("my")} ${t("payments")} ${t("history")}`;
  }
  if (location.pathname.endsWith("/make-payment")) {
    path = `${t("make")} ${t("payment")}`;
  }
  if (location.pathname.endsWith("/receive-payment")) {
    path = `${t("receive")} ${t("payment")}`;
  }
  if (location.pathname.endsWith("/manual-payment-history")) {
    path = `${t("manual")} ${t("payments")} ${t("history")}`;
  }
  if (location.pathname.endsWith("/receive-payment-history")) {
    path = `${t("receive")} ${t("payments")} ${t("history")}`;
  }
  if (location.pathname.endsWith("/manual-payment-complete")) {
    path = `${t("manual")} ${t("payment")} ${t("complete")}`;
  }
  if (location.pathname.endsWith("/receive-payment-complete")) {
    path = `${t("receive")} ${t("payment")} ${t("complete")}`;
  }
  if (location.pathname === "/payment-complete") {
    path = `${t("payment")} ${t("complete")}`;
  }
  if (location.pathname === "/school-payment-history") {
    path = `${t("school")} ${t("payment")} ${t("history")}`;
  }
  if (location.pathname === "/vendor-payment-history") {
    path = `${t("vendor")} ${t("payment")} ${t("history")}`;
  }
  if (location.pathname === "/parent-payment-history") {
    path = `${t("parent")} ${t("payment")} ${t("history")}`;
  }
  if (location.pathname === "/ratings-and-reviews") {
    path = `${t("ratings")} ${t("and")} ${t("reviews")}`;
  }
  if (location.pathname.endsWith("/school-ratings")) {
    path = `${t("school")} ${t("ratings")} ${t("and")} ${t("reviews")}`;
  }
  if (location.pathname.endsWith("/vendor-ratings")) {
    path = `${t("vendor")} ${t("ratings")} ${t("and")} ${t("reviews")}`;
  }
  if (location.pathname.endsWith("/school-vehicle-documents")) {
    path = `${t("school")} ${t("vehicle")} ${t("document")}`;
  }
  if (location.pathname.endsWith("/vendor-vehicle-documents")) {
    path = `${t("vendor")} ${t("vehicle")} ${t("document")}`;
  }
  if (location.pathname === "/system-config") {
    path = `${t("system")} & ${t("configuration")}`;
  }
  if (location.pathname === "/support") {
    path = `${t("support")} ${t("and")} ${t("troubleshooting")}`;
  }
  if (location.pathname === "/user-activity-logs") {
    path = `${t("user")} ${t("activity")} ${t("logs")}`;
  }
  if (location.pathname === "/reporting-and-analytics") {
    path = `${t("reporting")} ${t("and")} ${t("analytics")}`;
  }
  if (location.pathname === "/vehicle-make") {
    path = `${t("vehicle")} & ${t("make")}`;
  }
  if (location.pathname === "/vehicle-model") {
    path = `${t("vehicle")} & ${t("model")}`;
  }
  if (location.pathname === "/vehicle-year") {
    path = `${t("vehicle")} & ${t("year")}`;
  }
  if (location.pathname === "/vehicle-color") {
    path = `${t("vehicle")} & ${t("color")}`;
  }
  if (location.pathname === "/vehicle-type") {
    path = `${t("vehicle")} & ${t("type")}`;
  }
  if (location.pathname === "/vehicles/add") {
    path = `${t("add")} ${t("vehicle")}`;
  }
  if (location.pathname.startsWith("/vehicles/edit")) {
    path = `${t("edit")} ${t("vehicle")}`;
  }
  if (location.pathname === "/route-and-schedule") {
    path = `${t("route")} & ${t("schedule")}`;
  }
  if (location.pathname === "/route-and-schedule/add") {
    path = `${t("add")} ${t("route")} & ${t("schedule")}`;
  }
  if (location.pathname.startsWith("/route-and-schedule/edit")) {
    path = `${t("edit")} ${t("route")} & ${t("schedule")}`;
  }
  if (location.pathname === "/maintenance-and-inspection") {
    path = `${t("maintenance")} & ${t("inspection")}`;
  }
  if (location.pathname === "/maintenance-and-inspection/add") {
    path = `${t("add")} ${t("maintenance")} & ${t("inspection")}`;
  }
  if (location.pathname.startsWith("/maintenance-and-inspection/edit")) {
    path = `${t("edit")} ${t("maintenance")} & ${t("inspection")}`;
  }
  if (location.pathname === "/verification-logs") {
    path = `${t("verification")} ${t("logs")}`;
  }
  if (location.pathname === "/drivers") {
    path = `${t("drivers")}`;
  }
  if (location.pathname === "/drivers/add") {
    path = `${t("add")} ${t("drivers")}`;
  }
  if (location.pathname.startsWith("/drivers/edit/")) {
    path = `${t("edit")} ${t("drivers")}`;
  }
  if (
    location.pathname === "/bus-charter-reservations" ||
    location.pathname === "/my-bus-reservations"
  ) {
    path = `${t("bus")} ${t("charter")} ${t("reservations")}`;
  }
  if (location.pathname === "/school-bus-charter") {
    path = `${t("school")} ${t("bus")} ${t("charter")} ${t("reservations")}`;
  }
  if (location.pathname === "/busing-subscriptions") {
    path = `${t("busing")} ${t("subscriptions")}`;
  }
  if (location.pathname === "/school-busing-subscription") {
    path = `${t("school")} ${t("busing")} ${t("subscriptions")}`;
  }
  if (
    location.pathname === "/vendor-busing-subscriptions" ||
    location.pathname === "/vendor-busing-subscription"
  ) {
    path = `${t("vendor")} ${t("busing")} ${t("subscriptions")}`;
  }
  if (location.pathname === "/transfer-bus-charter") {
    path = `${t("outsourced")} ${t("bus")} ${t("charter")} ${t("reservations")}`;
  }
  if (location.pathname === "/transfer-busing-subscription") {
    path = `${t("outsourced")} ${t("busing")} ${t("subscriptions")}`;
  }
  if (location.pathname === "/my-busing-subscriptions") {
    path = `${t("busing")} ${t("subscriptions")}`;
  }
  if (location.pathname === "/subscription-plans") {
    path = `${t("subscription")} ${t("plans")}`;
  }
  if (location.pathname === "/bus-fee") {
    path = `${t("manage")} ${t("bus")} ${t("fee")}`;
  }
  if (location.pathname === "/school-bus-fee") {
    path = `${t("manage")} ${t("school")} ${t("bus")} ${t("fee")}`;
  }
  if (location.pathname === "/vendor-bus-fee") {
    path = `${t("manage")} ${t("vendor")} ${t("bus")} ${t("fee")}`;
  }
  if (location.pathname === "/user-communication") {
    path = `${t("user")} ${t("communication")}`;
  }
  if (location.pathname === "/settings") {
    path = `${t("settings")}`;
  }

  // LOGOUT API QUERY
  const [logout] = useLogoutMutation();

  const handleLogout = async () => {
    toast.dismiss();
    toast.success(`${t("logged")} ${t("out")} ${t("successfully")}.`);
    dispatch(logOutUser());
    removeToken();
    await purgeStore(); // ✅ All cache clear
    try {
      await logout().unwrap();
    } catch (_) {}
  };

  if (
    location.pathname === "/" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/register-school" ||
    location.pathname === "/registration"
  ) {
    return "";
  }

  return (
    <header className="dbHeader d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center gap-2">
        {/* Hamburger — visible only on mobile (≤991px), controls sidebar */}
        <button className="header-menu-btn" onClick={onToggleSidebar}>
          <IoMdMenu />
        </button>

        <div className="dbHd text-capitalize">{path}</div>
      </div>
      {user?.role === "vendor" && (
        <VendorHeader logOut={handleLogout} LanguageSlector={LanguageSlector} />
      )}
      {user?.role === "school" && (
        <SchoolHeader logOut={handleLogout} LanguageSlector={LanguageSlector} />
      )}
      {user?.role === "parent" && (
        <ParentHeader logOut={handleLogout} LanguageSlector={LanguageSlector} />
      )}
      {user?.role === "super_admin" && (
        <AdminHeader logOut={handleLogout} LanguageSlector={LanguageSlector} />
      )}
    </header>
  );
};

export default Header;
